var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import PageSection from '@/components/LandingPages/PageSection/PageSection';
import { Button } from '@/components/ui/Button/Button';
import { CampaignUpdateType } from '@/enum/CampaignUpdateType';
import { classNameMerge } from '@/lib/utils';
import appendQueryParams from '@/utils/appendQueryParams';
import { getVideoThumbnail } from '@/utils/getVideoThumbnail';
import { useLazyQuery } from '@apollo/client';
import { useEffect, useState } from 'react';
import Skeleton from 'react-loading-skeleton';
import GET_CAMPAIGN_UPDATE_THUMBNAIL from '../../queries/getCampaignUpdateThumbnail.gql';
import { CampaignCard } from '../CampaignCard/CampaignCard';
import UpdateContent from '../CampaignCard/components/UpdateContent/UpdateContent';
export default function UpdatesSection(_a) {
    var _this = this;
    var _b;
    var cache = _a.cache, isLoading = _a.isLoading, movement = _a.movement;
    var _c = useState('Recent Updates'), sectionTitle = _c[0], setSectionTitle = _c[1];
    var _d = useState([]), updates = _d[0], setUpdates = _d[1];
    var _e = useState(8), updatesToDisplay = _e[0], setUpdatesToDisplay = _e[1];
    var shouldShowLoader = isLoading || !movement || updates.length === 0;
    var getCampaignUpdateThumbnail = useLazyQuery(GET_CAMPAIGN_UPDATE_THUMBNAIL)[0];
    var loadUpdates = function () { return __awaiter(_this, void 0, void 0, function () {
        var cacheData, resolvedUpdates;
        var _this = this;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!movement) return [3 /*break*/, 2];
                    cacheData = cache.get(movement.slug);
                    if (!(cacheData === null || cacheData === void 0 ? void 0 : cacheData.updates)) return [3 /*break*/, 2];
                    return [4 /*yield*/, Promise.all(cacheData.updates.map(function (update) { return __awaiter(_this, void 0, void 0, function () {
                            var thumb, data, _a, playbackId, thumbnailToken;
                            var _b;
                            return __generator(this, function (_c) {
                                switch (_c.label) {
                                    case 0:
                                        if (update.updateType !== CampaignUpdateType.Video)
                                            return [2 /*return*/, update];
                                        if (!update.imageUrl) return [3 /*break*/, 2];
                                        return [4 /*yield*/, getVideoThumbnail(update.imageUrl)];
                                    case 1:
                                        thumb = _c.sent();
                                        return [2 /*return*/, __assign(__assign({}, update), { imageUrl: thumb })];
                                    case 2: return [4 /*yield*/, getCampaignUpdateThumbnail({ variables: { id: update.id } })];
                                    case 3:
                                        data = (_c.sent()).data;
                                        _a = (_b = data === null || data === void 0 ? void 0 : data.campaignUpdate) !== null && _b !== void 0 ? _b : {}, playbackId = _a.playbackId, thumbnailToken = _a.thumbnailToken;
                                        if (playbackId && thumbnailToken) {
                                            return [2 /*return*/, __assign(__assign({}, update), { imageUrl: "https://image.mux.com/".concat(playbackId, "/thumbnail.png?token=").concat(thumbnailToken, "&width=460") })];
                                        }
                                        return [2 /*return*/, __assign(__assign({}, update), { imageUrl: '' })];
                                }
                            });
                        }); }))];
                case 1:
                    resolvedUpdates = _a.sent();
                    setUpdates(resolvedUpdates);
                    _a.label = 2;
                case 2: return [2 /*return*/];
            }
        });
    }); };
    useEffect(function () {
        if (movement) {
            setSectionTitle("Recent ".concat(movement.movementName, " Updates"));
            loadUpdates();
        }
    }, [movement, cache]);
    var showMoreUpdates = function () { return setUpdatesToDisplay(updatesToDisplay + 4); };
    return (_jsxs(PageSection, { isLoading: shouldShowLoader, label: "".concat((_b = movement === null || movement === void 0 ? void 0 : movement.buttonText) !== null && _b !== void 0 ? _b : 'Trending', " Campaign Updates"), title: sectionTitle, children: [_jsx("div", { "aria-labelledby": "updates-section-title", className: classNameMerge('grid lgx:grid-cols-4 lg:grid-cols-3 md:grid-cols-2 grid-cols-1 gap-[24px] sm:gap-[32px]'), "data-testid": "update-card-container", children: shouldShowLoader ? (_jsxs(_Fragment, { children: [_jsx(Skeleton, { "aria-busy": "true", containerTestId: "campaign-skeleton", height: 280 }), _jsx(Skeleton, { "aria-busy": "true", containerTestId: "campaign-skeleton", height: 280 }), _jsx(Skeleton, { "aria-busy": "true", containerTestId: "campaign-skeleton", height: 280 })] })) : (updates.slice(0, updatesToDisplay).map(function (update, index) {
                    var utmParams = {
                        utm_campaign: update.campaignName.substring(0, 8),
                        utm_content: update.title.substring(0, 8),
                        utm_medium: 'homepage',
                        utm_source: 'campaign_update',
                    };
                    return (_jsx(CampaignCard, { headerImage: update.imageUrl, testid: "update-card", title: update.title, url: appendQueryParams(update.url, utmParams), children: _jsx(UpdateContent, { author: update.campaignName, description: update.description, postedAt: update.postedAt, title: update.title }) }, "".concat(update.title.toLowerCase().replaceAll(' ', '-'), "-").concat(index, "-card")));
                })) }), _jsx("div", { className: "w-full text-center mt-2", children: updatesToDisplay < updates.length && (_jsx(Button, { "aria-label": "Load more updates", className: classNameMerge("rounded-full font-bold text-sm sm:text-base mx-auto"), "data-testid": "see-more-updates-button", onClick: showMoreUpdates, size: "default", variant: "outline", children: "See More Updates" })) })] }));
}
